import { pageHead } from "@/lib/routeHead";
import { createFileRoute } from "@tanstack/react-router";
import MemberAuthCallbackPage from "@/pages/member/MemberAuthCallbackPage";

export const Route = createFileRoute("/member/auth/callback")({
  head: () => pageHead("Verifying Your Account", "Completing sign-in to the AI Innovation Network portal.", "/member/auth/callback", true),
  component: MemberAuthCallbackPage,
});
